import React, { Component } from 'react'

import PropTypes from 'prop-types'

import styles from './social.scss'

class PinterestButton extends Component {

	onSelectHandler = () => {
		this.props.onSelect()
	}

	render() {
		const pinterestObject = this.props.dataObject
		let pinterestUrl = ''
		let message = ''
		if (pinterestObject.url) {
			message += message === '' ? '?':'&'
			message +='url='+encodeURIComponent(pinterestObject.url)
		}
		if (pinterestObject.media) {
			message += message === '' ? '?':'&'
			message +='media='+pinterestObject.media
		}
		if (pinterestObject.description) {
			message += message === '' ? '?':'&'
			message +='description='+pinterestObject.description
		}
		pinterestUrl = 'http://www.pinterest.com/pin/create/button/' + message

		return <a className={styles.icon} href={pinterestUrl} target='_blank' rel='noopener noreferrer' onClick={this.onSelectHandler}>
			<svg width="50" height="50" viewBox="-7 -7 50 50" className={styles.svg}>
				<g fill="#6A686A" className={styles.g} >
					<path d="M18-4.917c12.657 0 22.917 10.26 22.917 22.917 0 12.657-10.26 22.917-22.917 22.917C5.343 40.917-4.917 30.657-4.917 18-4.901 5.35 5.35-4.901 18-4.917M18-7C4.193-7-7 4.193-7 18c0 13.808 11.193 25 25 25 13.808 0 25-11.192 25-25C43 4.193 31.808-7 18-7"/>
					<path d="M13.417 31.152a13.443 13.443 0 0 0 1.638-3.43c.208-.737 1.153-4.487 1.153-4.487a4.708 4.708 0 0 0 3.986 2.029c5.235 0 8.792-4.778 8.792-11.112 0-4.847-4.098-9.347-10.319-9.347-7.75 0-11.653 5.556-11.653 10.194 0 2.777 1.056 5.292 3.334 6.236a.57.57 0 0 0 .82-.416c.069-.278.25-1 .333-1.307a.776.776 0 0 0-.236-.902 4.74 4.74 0 0 1-1.083-3.389 7.723 7.723 0 0 1 8.027-7.82c4.39 0 6.792 2.68 6.792 6.264 0 4.708-2.083 8.667-5.166 8.667a2.53 2.53 0 0 1-2.584-3.141A34.032 34.032 0 0 0 18.64 13.4a2.18 2.18 0 0 0-2.138-2.347c-1.75 0-3.153 1.805-3.153 4.167-.026.891.14 1.776.486 2.598 0 0-1.792 7.57-2.097 8.888a13.972 13.972 0 0 0-.292 3.75 1.39 1.39 0 0 0 1.931.694"/>
				</g>
			</svg>
			{ this.props.shouldShowName && <span className={styles.name}>Pinterest</span> }
		</a>
	}
}

PinterestButton.defaultProps = {
	onSelect: () => {},
	shouldShowName: true,
}

PinterestButton.propTypes = {
	dataObject: PropTypes.object,
	onSelect: PropTypes.func,
	shouldShowName: PropTypes.bool,
}

export default PinterestButton
